module.exports = __webpack_public_path__ + "img/solutions-catalogue.dcf7d2c.webp";